import { FC } from 'react';
import cn from 'classnames';

import styles from 'components/Sections/OrangeAlert/OrangeAlert.module.scss';
import { DataLink } from 'components/Shared/SharedComponents';
import { OrangeAlertListItemInterface } from 'components/Sections/OrangeAlert/declarations';
import { capitalizeFirstLetter } from 'lib/text.service';
import { Icon } from 'components/Sections/OrangeAlert/Icon';

/* Main component */
const OrangeAlertListItem: FC<OrangeAlertListItemInterface> = ({
  link,
  mobileItemsLayout,
  mobileViewMaxWidth,
  commonTabletMaxWidth,
}) => {
  if (!link) {
    return null;
  }

  const { src, title, image, slug } = link;
  const isDivider = slug === 'divider';

  const content = isDivider ? null : (
    <>
      <Icon
        image={image!}
        mobileItemsLayout={mobileItemsLayout}
        mobileViewMaxWidth={mobileViewMaxWidth}
        commonTabletMaxWidth={commonTabletMaxWidth}
      />
      <span
        title={title!}
        className={styles.text}
      >
        {title}
      </span>
    </>
  );

  if (src === '#') {
    return (
      <li className={cn(styles.alertContentLi,
        styles[`alertContentLi${capitalizeFirstLetter(slug || '')}`],
        isDivider ? styles.divider : styles.alertContentLiNoLink)}
      >
        {content}
      </li>
    );
  }

  return (
    <li className={styles.alertContentLi}>
      <DataLink
        link={link}
        className={cn(styles.alertContentLiLink,
          styles[`alertContentLi${capitalizeFirstLetter(slug || '')}`])}
      >
        {content}
      </DataLink>
    </li>
  );
};

export default OrangeAlertListItem;
